import { defineStore } from "pinia";
import { ref } from "vue";

export const mobileMenuStore = defineStore("mobileMenuStore", () => {
  const isHidden = ref<boolean>(true);

  const getIsHidden = () => {
    return isHidden.value;
  };

  const toggleIsHidden = () => {
    isHidden.value = !isHidden.value;
  };
  return { getIsHidden, toggleIsHidden };
});
